"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataViewContext = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DataViewContext = _react["default"].createContext({
  dataViewId: null,
  dataType: null
});

exports.DataViewContext = DataViewContext;